import { action, observable } from "mobx";
import { url } from "./APIEndPoints";
import { Subject } from "rxjs";
import HttpService from "./HttpService"; 
import {
  ToastService,
  IAPIResponse,
  buildParamString,
  AuthService,
} from "@mindmemobile/mm-shared-global"; 
import { CategoryModel } from "../models/CategoryModels";
import { IAPICategoryModel } from "../interfaces/IAPIItemDetailPageCommonModel";

export default class CategoryService {
  @observable public categories: CategoryModel[] = [];
  private httpService: HttpService;
  constructor() {
    this.httpService = new HttpService(
      undefined,
      `${process.env.REACT_APP_API_KEY}`,
      process.env.REACT_APP_API_BASE_URL
    );

    this.loadCategories(AuthService.authData.accountId);
  }

  @action
  loadCategories(accountId: string) {
    if(!accountId) return;
    const params: string = buildParamString({
      accountId: accountId,
    });

    this.httpService
      .get<IAPIResponse<IAPICategoryModel[]>>(url.getAllCategories, params)
      .subscribe({
        next: (d) => {
          this.categories = CategoryModel.deserializeAPIModels(d.result);
        },
      });
  }

  @action createCategory(
    accountId: string,
    name: string,
    subject: Subject<CategoryModel>
  ) {
    const requestBody = {
      accountId: accountId,
      name: name,
    };

    this.httpService
      .post<IAPIResponse<IAPICategoryModel>>(url.createCategory, requestBody)
      .subscribe({
        next: (d) => {
          const mappedData = CategoryModel.deserializeAPIModel(d.result);

          const ifExists = this.categories.find((b) => b.id === mappedData.id);
          if (mappedData && !ifExists) {
            this.categories.push(mappedData);
          }
          subject.next(mappedData);
        },
        error: (e) => {
          ToastService.showError("Error Occured");
          subject.error(e);
        },
      });
  }
}
